import { render, staticRenderFns } from "./CurrentDischarge.vue?vue&type=template&id=27b5015d&"
import script from "./CurrentDischarge.vue?vue&type=script&lang=js&"
export * from "./CurrentDischarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports